var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuTutorial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.867,
    height: 20.889,
    viewBox: "0 0 20.867 20.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1132",
    "data-name": "Rectangle 1132",
    width: 20.868,
    height: 20.889,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3586",
    "data-name": "Group 3586",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2869",
    "data-name": "Path 2869",
    d: "M20.868,11.282a13.7,13.7,0,0,1-.288,1.68,10.575,10.575,0,0,1-1.417,3.205.842.842,0,1,1-1.413-.909,8.67,8.67,0,0,0,1.325-3.322,8.523,8.523,0,0,0-1.156-6.075A8.467,8.467,0,0,0,12.15,1.833,8.492,8.492,0,0,0,4.82,3.708,8.379,8.379,0,0,0,1.844,8.717,8.528,8.528,0,0,0,3.53,15.81a8.475,8.475,0,0,0,5.2,3.214,8.631,8.631,0,0,0,6.016-.955,1.382,1.382,0,0,1,.554-.243.824.824,0,0,1,.906.564A.838.838,0,0,1,15.8,19.4a10.659,10.659,0,0,1-2.223,1,9.72,9.72,0,0,1-3.876.453,10.3,10.3,0,0,1-8.616-5.759A9.38,9.38,0,0,1,.039,11.4,10.241,10.241,0,0,1,3.327,2.776,10.027,10.027,0,0,1,8.8.105c.247-.039.5-.07.743-.105h1.792c.334.049.669.091,1,.149A10.47,10.47,0,0,1,20.6,7.931a15.465,15.465,0,0,1,.271,1.6Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2870",
    "data-name": "Path 2870",
    d: "M104.45,98.925q0-1.18,0-2.361a1.718,1.718,0,0,1,2.5-1.537c.74.384,1.449.826,2.171,1.244.652.377,1.3.767,1.954,1.132a1.758,1.758,0,0,1,0,3.072c-1.335.753-2.651,1.539-3.98,2.3a1.74,1.74,0,0,1-2.616-1.128,1.444,1.444,0,0,1-.026-.3q0-1.211,0-2.422m1.657,0q0,1.079,0,2.157c0,.276.039.3.273.167q1.876-1.084,3.75-2.172c.2-.115.2-.159.007-.271q-1.883-1.093-3.768-2.182c-.22-.127-.262-.1-.262.164q0,1.068,0,2.137",
    transform: "translate(-97.485 -88.511)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuTutorial);
export default __webpack_public_path__ + "static/media/icon_menu_tutorial.eca31710654dbc1bc8581994ca660f09.svg";
export { ForwardRef as ReactComponent };